module.exports = __webpack_public_path__ + "img/ft-flip-hor.6d0bea23.svg";